class ProductHelper {
    calculateTotals({ quantity, unitPrice, discountRate, scheme }) {
        let taxAmount = 0
        let subtotal = 0
        for (let tax of scheme.value) {
            if (scheme.taxInclusive) {
                unitPrice = +unitPrice / (+tax.taxRate + 1)
                subtotal = +quantity * +unitPrice
            }

            taxAmount += +subtotal * +tax.taxRate
        }

        const discount = +subtotal * (+discountRate / 100)
        const total = (+subtotal - +discount) + +taxAmount

        return {
            subtotal,
            discount,
            taxAmount,
            unitPrice,
            total
        }
    }
}

const productHelper = new ProductHelper()

export default productHelper